document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.getElementById('stickyBtns');
  const heroes = Array.from(document.querySelectorAll('[data-sticky-hero]'));
  if (!buttons || !heroes.length) return;

  function updateVisibility() {
    // Landing pages have separate desktop and mobile hero images.
    const visibleHeroes = heroes.map(hero => hero.getBoundingClientRect())
      .filter(rect => rect.width > 0 && rect.height > 0);
    buttons.hidden = !visibleHeroes.length || visibleHeroes.some(rect => rect.bottom > 0);
    if (buttons.hidden && window.bootstrap) {
      buttons.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(trigger => {
        const tooltip = window.bootstrap.Tooltip.getInstance(trigger);
        if (tooltip) tooltip.hide();
      });
    }
  }

  const observer = new IntersectionObserver(updateVisibility, { threshold: 0 });
  heroes.forEach(hero => observer.observe(hero));
  window.addEventListener('resize', updateVisibility);
  window.addEventListener('pageshow', updateVisibility);
  updateVisibility();
});
